var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "telegram-channel",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#61D81D;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "color",
    className: "st0",
    cx: 9.2,
    cy: 20,
    r: 5.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M27.5,12.1l-17.3,6.5C9,19.1,9,19.7,9.9,20l4.4,1.4L24.7,15c0.5-0.3,0.9-0.1,0.6,0.2l-8.3,7.3l0,0 L16.6,27c0.4,0,0.7-0.2,0.9-0.4l2.2-2l4.5,3.2c0.8,0.5,1.4,0.2,1.6-0.8l3-13.6C29,12.3,28.2,11.7,27.5,12.1L27.5,12.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.3af2c8bb8d7ae7363a5efbd9e7c65e6c.svg";
export { ForwardRef as ReactComponent };